import React , { useEffect, useState } from "react";


const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 16px",
    background:
      "radial-gradient(1200px 600px at 10% -10%, #e8efff 0%, transparent 60%), radial-gradient(900px 500px at 110% 110%, #fff0e6 0%, transparent 55%), #f7f9fc",
    fontFamily:
      "Brandon Grot W01 Light, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', Arial, sans-serif",
    color: "#1f2937",
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: 560,
    background: "#ffffff",
    borderRadius: 16,
    boxShadow:
      "0 10px 30px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.04)",
    border: "1px solid rgba(15, 23, 42, 0.06)",
    padding: "40px 32px",
    textAlign: "center",
    boxSizing: "border-box",
  },
  iconWrap: {
    width: 88,
    height: 88,
    margin: "0 auto 20px",
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(255, 159, 67, 0.18), rgba(255, 99, 99, 0.18))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    margin: "0 0 8px",
    fontSize: 26,
    lineHeight: 1.2,
    fontWeight: 700,
    color: "#495057",
  },
  subtitle: {
    margin: "0 0 28px",
    fontSize: 16,
    lineHeight: 1.6,
    color: "#475569",
  },
  errorCode: {
    display: "inline-block",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.6,
    padding: "4px 10px",
    color: "#b45309",
    background: "#fef3c7",
    borderRadius: 999,
    marginBottom: 16,
    textTransform: "uppercase",
  },
  actions: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  buttonPrimary: {
    appearance: "none",
    border: "none",
    cursor: "pointer",
    padding: "12px 22px",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    color: "#ffffff",
   background:"#ec2e7b",  // "linear-gradient(135deg, #ec2e7b, #E619D1)",
    boxShadow: "0 6px 16px rgba(79, 70, 229, 0.35)",
    transition: "transform 0.08s ease, box-shadow 0.2s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
  },
  buttonSecondary: {
    appearance: "none",
    cursor: "pointer",
    padding: "12px 22px",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    color: "#1f2937",
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    transition: "background 0.2s ease, border-color 0.2s ease",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
  },
  helper: {
    marginTop: 28,
    paddingTop: 20,
    borderTop: "1px solid #eef2f7",
    fontSize: 15,
    color: "#64748b",
    lineHeight: 1.6,
  },
  link: {
    color: "#4f46e5",
    textDecoration: "none",
    fontWeight: 600,
  },
  countdown: {
    display: "block",
    marginTop: 12,
    fontSize: 14,
    color: "#94a3b8",
  },
};

const AUTO_HOME_SECONDS = 30;

function WarningIcon() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#ef6c1a"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}


function ErrorPage() {
    const [secondsLeft, setSecondsLeft] = useState(AUTO_HOME_SECONDS);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  useEffect(() => {
    if (secondsLeft === 0) {
      window.location.replace("/");
    }
  }, [secondsLeft]);

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.replace("/");
  };
  return (
     <main style={styles.page} role="main">
     
   
      <section style={styles.card} aria-labelledby="error-title">
        <div> <img
        className="swallow-logo-login header"
        src="/assets/images/logo-swallow.jpg"
        alt=""
      /></div>
       
        <div style={styles.iconWrap}>
           
          <WarningIcon />
        </div>

        <span style={styles.errorCode}>Unexpected error</span>

        <h1 id="error-title" style={styles.title}>
          Something went wrong
        </h1>

        <p style={styles.subtitle}>
          Try reloading, or head back to the home page and continue from there.
        </p>

        <div style={styles.actions}>
          {/* <button
            type="button"
            onClick={handleReload}
            style={styles.buttonPrimary}
          >
            Try again
          </button> */}
          <button
            type="button"
            onClick={handleGoHome}
            style={styles.buttonPrimary}
          >
            Go to home
          </button>
        </div>

        <div style={styles.helper}>
          If this keeps happening, please{" "}contact support
          {/* <a href="mailto:support@swallowevents.com" style={styles.link}>
            contact support
          </a> */}
          .
          <span style={styles.countdown}>
            Returning home automatically in {secondsLeft}s
          </span>
        </div>
      </section>
    
    </main>
    // <React.Fragment>
    //   <section className="loginswallow-dashboard">
    //     <div className="page-not-found">
    //       <h1>⚠️ Something Went Wrong</h1>
    //       <p>
    //         Your session has expired or your connection was interrupted. Please
    //         return to the Home page or log in again.
    //       </p>
    //       <Link to="/">Go to Home</Link>
    //     </div>
    //   </section>
    // </React.Fragment>
  );
}

export default ErrorPage;
